import React from "react";
import styles from "./CustomGroupedRadioButton.module.scss";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

interface CustomGroupedRadioButtonProps {
  inputFormTitle?: string;
  value: boolean;
  changeTrigger: (value: boolean) => void;
  options: { value: boolean; label: string }[];
  disabled?: boolean;
}

const CustomGroupedRadioButton: React.FC<CustomGroupedRadioButtonProps> = ({
  inputFormTitle,
  value,
  changeTrigger,
  options,
  disabled = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    changeTrigger(event.target.value === "true");
  };

  return (
    <FormControl component="fieldset" disabled={disabled} fullWidth>
      {inputFormTitle && <FormLabel>{inputFormTitle}</FormLabel>}
      <RadioGroup
        value={value}
        onChange={handleChange}
        aria-label={inputFormTitle}
        name="custom-grouped-radio"
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "2rem",
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.label}
            value={option.value}
            control={<Radio className={styles.customRadio} />}
            label={option.label}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px",
                fontWeight: 400,
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomGroupedRadioButton;
